<template>
  <v-container>
    <v-row>
      <v-col
        v-if="whitelabel.loginPageMessage"
        cols="12"
        md="8"
        offset-md="2"
        lg="6"
        offset-lg="3"
        class="mb-2"
      >
        <p
          class="signup-page-message"
          :class="{ 'mt-4': $vuetify.breakpoint.smAndDown }"
          v-html="whitelabel.loginPageMessage"
        />
      </v-col>
      <v-col cols="12" md="6" offset-md="4" class="mb-3">
        <h2>Log in</h2>
      </v-col>
      <v-col cols="12" md="4" offset-md="4">
        <ValidationObserver ref="observer">
          <v-form @submit.prevent="submit">
            <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
            <ValidationProvider
              :id="whitelabel.authentication.login.fieldName"
              v-slot="{ errors }"
              :name="whitelabel.authentication.login.fieldName"
              :rules="whitelabel.authentication.login.validation"
            >
              <v-text-field
                v-model="uniqueIdentifier"
                :label="whitelabel.authentication.login.fieldTitle"
                :error-messages="errors"
              />
            </ValidationProvider>
            <ValidationProvider
              id="password"
              v-slot="{ errors }"
              name="password"
              rules="required"
            >
              <v-text-field
                v-model="password"
                :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
                :type="showPassword ? 'text' : 'password'"
                label="Password"
                :error-messages="errors"
                @click:append="showPassword = !showPassword"
              />
            </ValidationProvider>
            <v-row no-gutters>
              <v-col cols="12">
                <router-link :to="{ name: 'ForgotPassword' }" class="pl-2"
                  >Forgot password?</router-link
                >
              </v-col>
            </v-row>

            <v-btn
              @click="sendGADataLayer"
              rounded
              large
              depressed
              type="submit"
              color="primary"
              class="mt-9 mx-0"
              :loading="buttonLoading"
            >
              <span>Log in</span><v-icon>{{ icons.mdiArrowRight }}</v-icon>
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import loginService from "../../services/LoginService";

export default {
  name: "Login",
  metaInfo() {
    return {
      link: [
        {
          rel: "canonical",
          href: this.whitelabel.canonicalUrls.login,
        },
      ],
    };
  },
  props: {
    prepopulatedEmail: {
      required: false,
      type: String,
      default: null,
    },
  },
  data() {
    return {
      uniqueIdentifier: this.prepopulatedEmail,
      password: null,
      errorMessage: null,
      showPassword: false,
      buttonLoading: false,
    };
  },
  computed: {
    isAdminOrAdvisor() {
      return (
        this.$store.getters.isAdmin ||
        this.$store.getters.isAdvisor ||
        this.$store.getters.isCompanyAdmin
      );
    },
    isLeadProvider() {
      return this.$store.getters.isLeadProvider;
    },
  },
  created() {
    if (this.$route.query.error == 1) {
      this.errorMessage = "Access denied. Please login.";
    } else if (this.$route.query.error == 2) {
      this.errorMessage = "Session timed out";
    }
  },
  methods: {
    sendGADataLayer() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "log-in",
        omuserid: this.$store.getters?.userId,
      });
    },
    submit() {
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          this.buttonLoading = true;
          this.login();
        } else {
          const errors = this.$refs.observer.ctx.errors;
          document
            .getElementById(
              Object.keys(errors).find((field) => errors[field].length)
            )
            .scrollIntoView({ block: "center", behavior: "smooth" });
        }
      });
    },
    login() {
      const uniqueIdentifier = this.uniqueIdentifier;
      const password = this.password;
      loginService
        .login(this.uniqueIdentifier, this.password, this.$apollo, this.$store)
        .then((result) => {
          if (result.message?.includes("GraphQL error")) {
            throw result;
          }
          const login = result.data.login;
          const accessToken = login.accessToken;
          const refreshToken = login.refreshToken;
          const testatorId = login.testatorId;
          const userId = login.userId;
          const willCountry = login.willCountry;
          const companyId = login.companyId;

          this.$store.dispatch("login", {
            accessToken,
            refreshToken,
            testatorId,
            userId,
            willCountry,
            companyId,
          });
          loginService.setSentryUser(userId);
          loginService.redirectToNext(this.$router);
        })
        .catch((error) => {
          this.onError(error);
        });
    },
    onError(error) {
      this.buttonLoading = false;
      if (error.message.includes("GraphQL error:")) {
        this.errorMessage = error.message.replace("GraphQL error:", "").trim();
      } else {
        this.errorMessage =
          "Something went wrong, we're looking into it. Please try login again.";
        throw error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page-message {
  text-align: center;
}

#customBtn {
  display: inline-block;
  background: white;
  color: #444;
  width: 190px;
  border-radius: 5px;
  border: thin solid #888;
  box-shadow: 1px 1px 1px grey;
  white-space: nowrap;
}
#customBtn:hover {
  cursor: pointer;
}
span.label {
  font-family: serif;
  font-weight: normal;
}
span.icon {
  background: url("/identity/sign-in/g-normal.png") transparent 5px 50%
    no-repeat;
  display: inline-block;
  vertical-align: middle;
  width: 42px;
  height: 42px;
}
span.buttonText {
  display: inline-block;
  vertical-align: middle;
  padding-left: 42px;
  padding-right: 42px;
  font-size: 14px;
  font-weight: bold;
  /* Use the Roboto font that is loaded in the <head> */
  font-family: "Roboto", sans-serif;
}
</style>
